import { AddIcon } from '@approvalmax/ui';
import { Box, Button, Grid, Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { memo, useMemo } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { useIntegrationTypeDecision } from '../../hooks/useIntegrationTypeDecision';
import { DisconnectedAlert } from '../DisconnectedAlert/DisconnectedAlert';
import { PullQBooksBudgetButton } from '../PullQBooksBudgetButton/PullQBooksBudgetButton';
import PullXeroBudgetButton from '../PullXeroBudgetButton/PullXeroBudgetButton';
import { messages } from './NoBudgets.messages';
import { NoBudgetsProps } from './NoBudgets.types';

export const NoBudgets = memo<NoBudgetsProps>((props) => {
    const { isLoading, canCreateBudget, onUploadNewBudget } = props;

    const company = useCompanyBasedOnUrl();
    const integrationTypeDecision = useIntegrationTypeDecision();

    const isDisconnected = !company.flags.hasActiveIntegration;

    const pullBudgetButton = useMemo(() => {
        switch (integrationTypeDecision) {
            case domain.IntegrationType.Xero:
                return <PullXeroBudgetButton />;

            case domain.IntegrationType.QBooks:
                return <PullQBooksBudgetButton />;

            default:
                return null;
        }
    }, [integrationTypeDecision]);

    if (isDisconnected) {
        return <DisconnectedAlert isNoBudgets />;
    }

    return (
        <Box spacing='24' width={480} bordered radius='small'>
            <Grid rowGap={24}>
                <Text color='midnight80' font='headline' fontSize='small' fontWeight='medium' textAlign='center'>
                    {messages.title}
                </Text>

                <Grid rowGap={8}>
                    {canCreateBudget && (
                        <>
                            <Button
                                onClick={onUploadNewBudget}
                                disabled={company.isReadonly}
                                color='blue80'
                                block
                                startIcon={<AddIcon />}
                                size='large'
                                progress={isLoading}
                            >
                                {messages.uploadFirstBudget}
                            </Button>

                            <Text font='body' textAlign='center' color='midnight80'>
                                {messages.or}
                            </Text>
                        </>
                    )}

                    {pullBudgetButton}
                </Grid>
            </Grid>
        </Box>
    );
});

NoBudgets.displayName = 'NoBudgets';
